import {styled} from '@mui/material';
import Icon from 'presentation/icons';

const StyledIcon = styled(Icon)`
	min-width: 20px;
	min-height: 20px;
	fill: ${({theme}) => theme.palette.primary.main};
`;

export {StyledIcon};
